(function () {
  var root = document.querySelector('[data-am]');
  if (!root) return;
  var P = JSON.parse(root.querySelector('[data-am-data]').textContent);
  var log = root.querySelector('[data-am-log]');
  var form = root.querySelector('[data-am-form]');
  var input = root.querySelector('[data-am-input]');
  var reset = root.querySelector('[data-am-reset]');

  var NAME = { ipp: 'Itchy Pet Protocol', gi: 'Gut & Immunity+', lm: 'Lean Mass+', jm: 'Joint & Mobility+', fc: 'Focus & Calm', pk: 'Puppy/Kitten',
    pb: 'Probiotics 3P', tt: 'Turkey Tail', ur: 'Urinary', pr: 'PROTECT Spray', od: 'OUTDOOR Spray', lg: 'Leaky Gut Protocol',
    senior: 'Senior Pet Protocol', starter: 'Puppy & Kitten Starter Bundle', travel: 'Travel Pack', lumps: 'Lumps & Bumps Bundle' };
  var PARTS = { ipp: ['gi', 'lm', 'pr'], lg: ['gi', 'lm'], senior: ['jm', 'gi', 'fc'], starter: ['pk', 'pr'], travel: ['fc', 'pr'], lumps: ['tt', 'gi'] };
  var POWDERS = ['gi', 'lm', 'jm', 'fc', 'pk', 'pb', 'tt', 'ur'];

  var C = [
    { id: 'itch', l: 'itchy skin & allergies', re: /itch|scratch|allerg|hot ?spots?|red skin|rash|hives|dandruff|flak|hair loss|bald|lick(s|ing)? (her|his|their|its)? ?(paws?|feet|belly|legs?|skin)|paw lick|chew(s|ing)? (on )?(her|his|their|its)? ?(paws?|feet|legs?)/i, w: { ipp: 6, gi: 3, pr: 3, lg: 1 } },
    { id: 'yeast', l: 'yeasty ears & odour', re: /yeast|smell|stink|odou?r|corn ?chip|ear (infection|gunk|wax|issue)|\bears?\b|greasy/i, w: { ipp: 4, gi: 3, pr: 2 } },
    { id: 'tear', l: 'tear stains', re: /tear ?stain|eye discharge|weepy eye|eye goop/i, w: { gi: 5 } },
    { id: 'gut', l: 'tummy troubles', re: /diarr|loose|soft stool|runny|stool|poop|vomit|throw(s|ing)? up|upset (stomach|tummy)|sensitive (stomach|tummy)|gas(sy)?\b|fart|bloat|constipat|ibd|colitis|digest/i, w: { lg: 5, pb: 4, gi: 3 } },
    { id: 'leaky', l: 'leaky gut', re: /leaky gut|malabsor|absorb/i, w: { lg: 7, lm: 3, gi: 2 } },
    { id: 'abx', l: 'recent antibiotics', re: /antibiotic/i, w: { pb: 6, gi: 2 } },
    { id: 'food', l: 'food sensitivities', re: /food (allerg|sensitiv|intoler)|beef|chicken allerg|new food|switch(ing|ed)? (food|diet)/i, w: { pb: 3, gi: 3, lg: 2 } },
    { id: 'joint', l: 'stiff joints & mobility', re: /joint|arthrit|stiff|limp|\bhips?\b|dysplas|elbow|knee|acl|cruciate|mobility|slow to get up|trouble (getting up|walking|jumping)|stairs|sore legs/i, w: { jm: 7, senior: 2 } },
    { id: 'anx', l: 'anxiety & stress', re: /anx|nervous|stress|fear|scared|firework|thunder|storm|separation|hyper|reactive|bark|pacing|restless|panic|calm/i, w: { fc: 7 } },
    { id: 'travel', l: 'travel & big changes', re: /travel|car ride|road trip|\bfl(y|ight)|plane|moving|new home|boarding|kennel|groom/i, w: { travel: 6, fc: 3 } },
    { id: 'seiz', l: 'seizures', re: /seizure|epilep/i, w: { fc: 5 }, vet: 1 },
    { id: 'sleep', l: 'restless nights', re: /sleep|insomnia|up at night|all night/i, w: { fc: 3 } },
    { id: 'urin', l: 'urinary health', re: /\burin|bladder|\buti\b|crystal|stones?\b|\bpee|kidney|incontin|accidents/i, w: { ur: 8 } },
    { id: 'lump', l: 'lumps & bumps', re: /lump|bump|tumou?r|\bmass\b|cancer|lipoma|growth on/i, w: { lumps: 8, tt: 4, gi: 2 }, vet: 1 },
    { id: 'immune', l: 'immune support', re: /immun|always sick|sick often|infections/i, w: { tt: 4, gi: 4 } },
    { id: 'muscle', l: 'muscle, weight & recovery', re: /muscle|underweight|too thin|skinny|weight loss|losing weight|gain weight|surgery|injur|recover|rehab|active|agility|working dog|sport|athlet/i, w: { lm: 7, jm: 2 } },
    { id: 'wound', l: 'cuts, bites & skin folds', re: /wound|\bcuts?\b|scrape|bite|incision|skin folds?|wrinkle/i, w: { pr: 7 } },
    { id: 'outdoor', l: 'time outdoors', re: /hike|hiking|camp|cottage|trail|outdoor|walks\b|ticks?\b|mosquito|bugs\b/i, w: { od: 5, pr: 1 } },
    { id: 'puppy', l: 'healthy growth', re: /puppy|puppies|kitten|weeks old|baby/i, w: { pk: 7, starter: 4 } },
    { id: 'senior', l: 'the senior years', re: /senior|\bold(er)? (dog|cat|girl|boy|guy)|aging|ageing|geriatric|grey muzzle|slowing down/i, w: { senior: 7, jm: 3, tt: 2 } },
    { id: 'teeth', l: 'teeth & bones', re: /teeth|tooth|dental|\bbones?\b/i, w: { jm: 3 } },
    { id: 'liver', l: 'liver & detox', re: /liver|detox/i, w: { jm: 3 } },
    { id: 'cog', l: 'cognitive changes', re: /confus|dementia|cognitive|memory|disorient/i, w: { fc: 4, senior: 4 } },
    { id: 'well', l: 'everyday wellness', re: /general|overall|wellness|healthy|maintenance|prevent|nothing wrong/i, w: { gi: 4, pb: 2 } }
  ];
  var DOGB = /(labrador|\blab\b|golden retriever|\bgolden\b|german shepherd|\bgsd\b|french bulldog|frenchie|bulldog|\bpug\b|boxer|beagle|poodle|doodle|husky|rottweiler|rottie|dachshund|yorkie|yorkshire|shih ?tzu|chihuahua|great dane|bernese|mastiff|pit ?bull|bully|staffie|staffy|terrier|westie|cocker|spaniel|border collie|collie|aussie|australian shepherd|corgi|maltese|havanese|dogo|cavalier|schnauzer|doberman|shar ?pei|newfoundland|samoyed|malinois|vizsla|weimaraner|pointer|bichon|shepherd|retriever|hound|mixed breed|rescue mutt|mutt)/i;
  var CATB = /(persian|siamese|maine coon|ragdoll|bengal|sphynx|british shorthair|scottish fold|himalayan|tabby|domestic shorthair|dsh\b|calico|tuxedo)/i;
  var SKINB = /(frenchie|french bulldog|bulldog|\bpug\b|pit ?bull|bully|staff|westie|shar ?pei|boxer|golden|\blab\b|labrador|doodle|cocker|dogo|terrier)/i;
  var BIGB = /(\blab\b|labrador|golden|german shepherd|\bgsd\b|rottweiler|rottie|great dane|bernese|mastiff|newfoundland|dogo|malinois|doberman)/i;
  var FLAG = /blood|bloody|not eating|won'?t eat|stopped eating|letharg|collapse|difficulty breathing|can'?t breathe|straining|swollen belly|poison|ate (chocolate|grapes|raisins)|emergency|getting worse fast/i;
  var MEDS = /apoquel|cytopoint|prednis|steroid|medication|\bmeds\b|insulin|gabapentin|trazodone|rimadyl|carprofen|metacam|phenobarb|on pills/i;
  var DIET = /\braw\b|kibble|homemade|home-cooked|wet food|canned|dry food|grain[- ]free|fresh food/i;

  var S;
  function fresh() { S = { species: '', breed: '', age: null, lb: null, hit: {}, flag: false, meds: false, diet: false, vet: false, turns: 0 }; }
  fresh();

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function parse(t) {
    var m;
    var isCat = /\b(cat|cats|kitty|kitten|feline)\b/i.test(t) || CATB.test(t);
    var isDog = /\b(dog|dogs|pup|puppy|canine|doggo|pupper)\b/i.test(t) || DOGB.test(t);
    if (isCat && !isDog) S.species = 'cat'; else if (isDog && !isCat) S.species = 'dog';
    if ((m = t.match(DOGB)) || (m = t.match(CATB))) S.breed = m[1].replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*(?:lbs?|pounds?|#)\b/i))) S.lb = parseFloat(m[1]);
    else if ((m = t.match(/(\d+(?:\.\d+)?)\s*(?:kgs?|kilos?|kilograms?)\b/i))) S.lb = Math.round(parseFloat(m[1]) * 2.2046);
    if ((m = t.match(/(\d+(?:\.\d+)?)[\s-]*(?:years?|yrs?|yo|y\/o)\b/i))) S.age = parseFloat(m[1]);
    else if ((m = t.match(/(\d+)[\s-]*(?:months?|mos?)\b/i))) S.age = parseFloat(m[1]) / 12;
    else if ((m = t.match(/(\d+)[\s-]*(?:weeks?|wks?)\b/i))) S.age = parseFloat(m[1]) / 52;
    C.forEach(function (c) { if (c.re.test(t)) { S.hit[c.id] = 1; if (c.vet) S.vet = true; } });
    if (S.age !== null) {
      if (S.age < 1) S.hit.puppy = 1;
      if ((S.species !== 'cat' && S.age >= 7) || (S.species === 'cat' && S.age >= 10)) S.hit.senior = 1;
    }
    if (FLAG.test(t)) S.flag = true;
    if (MEDS.test(t)) S.meds = true;
    if (DIET.test(t)) S.diet = true;
  }

  function rank() {
    var sc = {}, why = {};
    C.forEach(function (c) {
      if (!S.hit[c.id]) return;
      for (var k in c.w) { sc[k] = (sc[k] || 0) + c.w[k]; (why[k] = why[k] || []).push(c.l); }
    });
    if (S.breed && SKINB.test(S.breed) && (S.hit.itch || S.hit.yeast)) { sc.ipp = (sc.ipp || 0) + 2; }
    if (S.breed && BIGB.test(S.breed)) { sc.jm = (sc.jm || 0) + 1; }
    if (S.species === 'cat') { delete sc.od; }
    if (S.hit.puppy) { delete sc.senior; }
    var base = {}; for (var b in sc) base[b] = sc[b];
    for (var bk in PARTS) {
      if (!sc[bk]) continue;
      var hits = PARTS[bk].filter(function (q) { return q !== 'pr' && base[q] > 0; });
      if (hits.length >= 2) sc[bk] += 0.6 * hits.reduce(function (a, q) { return a + base[q]; }, 0);
    }
    var keys = Object.keys(sc).filter(function (k) { return P[k]; }).sort(function (a, b) { return sc[b] - sc[a]; });
    var out = [], used = {};
    keys.forEach(function (k) {
      if (out.length >= 3 || used[k]) return;
      if (PARTS[k] && PARTS[k].every(function (q) { return used[q]; })) return;
      out.push(k); used[k] = 1;
      (PARTS[k] || []).forEach(function (p) { used[p] = 1; });
    });
    return { list: out, why: why };
  }

  function scoop(lb) {
    if (lb == null) return '';
    if (lb <= 25) return '½ scoop';
    if (lb <= 50) return '1 scoop';
    if (lb <= 75) return '1½ scoops';
    if (lb <= 100) return '2 scoops';
    return '3 scoops';
  }
  function dose(k) {
    var s = scoop(S.lb);
    if (k === 'pr') return 'Spray itchy or irritated spots 1–4× a day';
    if (k === 'od') return 'Spray on the coat before outdoor time';
    if (k === 'ipp') return (s ? s + ' each of Gut & Immunity+ and Lean Mass+' : 'One serving each of both powders') + ' morning and night, plus PROTECT whenever they itch';
    if (k === 'travel') return (s ? s + ' of Focus & Calm' : 'Focus & Calm') + ' daily (2× on travel days), plus PROTECT as needed';
    if (k === 'starter') return (s ? s + ' of Puppy/Kitten' : 'Puppy/Kitten') + ' daily, plus PROTECT as needed';
    if (PARTS[k]) return (s ? s + ' of each formula' : 'One serving of each formula') + ' on food daily';
    return s ? s + ' on food, once a day' : 'One serving on food daily (tell me their weight for the exact scoop)';
  }

  function card(k, top) {
    var p = P[k], why = (rank().why[k] || []).slice(0, 3).join(', ');
    return '<div class="am-card' + (top ? ' am-card--top' : '') + '">' +
      (top ? '<span class="am-badge">Mikvah’s pick</span>' : '') +
      '<a class="am-img" href="' + p.u + '">' + (p.i ? '<img src="' + p.i + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="am-cb"><a class="am-name" href="' + p.u + '">' + esc(NAME[k]) + '</a>' +
      (why ? '<span class="am-why">For ' + esc(why) + '</span>' : '') +
      '<span class="am-dose">' + esc(dose(k)) + '</span>' +
      '<div class="am-act"><button type="button" class="am-add" data-v="' + p.v + '">Add to cart · ' + esc(p.p) + '</button><a href="' + p.u + '">Details</a></div></div></div>';
  }

  function about() {
    var adj = [];
    if (S.age !== null) adj.push(S.age < 1 ? Math.max(1, Math.round(S.age * 12)) + '-month-old' : (Math.round(S.age * 10) / 10) + '-year-old');
    if (S.lb) adj.push(S.lb + ' lb');
    var who = S.breed || (S.species === 'cat' ? 'cat' : S.species === 'dog' ? 'dog' : 'pet');
    var tags = C.filter(function (c) { return S.hit[c.id] && c.id !== 'puppy' && c.id !== 'senior'; }).map(function (c) { return c.l; }).slice(0, 4);
    var t = tags.length > 1 ? tags.slice(0, -1).join(', ') + ' and ' + tags[tags.length - 1] : (tags[0] || '');
    var phrase = (adj.length ? adj.join(', ') + ' ' : '') + who;
    return (/^[aeiou8]|^11|^18/i.test(phrase) ? 'an ' : 'a ') + phrase + (t ? ' with ' + t : '');
  }

  function say(html, who) {
    var d = document.createElement('div');
    d.className = 'am-msg am-msg--' + who;
    d.innerHTML = html;
    log.appendChild(d);
    log.scrollTop = log.scrollHeight;
    return d;
  }

  function reply() {
    var r = rank();
    if (!r.list.length) {
      return '<p>I want to point you to the right thing. What’s going on with your pet? For example itching, tummy troubles, stiff joints, anxiety, urinary issues, lumps, or just everyday wellness. Their age and weight help too.</p>';
    }
    var h = '<p>Got it: ' + esc(about()) + '. Here’s what I’d suggest.</p><div class="am-cards">';
    r.list.forEach(function (k, i) { h += card(k, i === 0); });
    h += '</div>';
    var notes = [];
    if (S.flag) notes.push('Some of what you describe should be checked by your vet soon. Supplements support the body but don’t replace a diagnosis.');
    else if (S.vet) notes.push('For this, use our formulas alongside your veterinarian’s care.');
    if (S.meds) notes.push('If your pet takes medication, check with your vet before adding a supplement.');
    if (S.diet) notes.push('All our powders mix easily into raw, kibble, wet or homemade food.');
    if (S.breed && SKINB.test(S.breed) && (S.hit.itch || S.hit.yeast)) notes.push(S.breed + 's are often prone to skin and gut-related itch, which is exactly what the Itchy Pet Protocol targets.');
    if (S.lb == null && r.list.some(function (k) { return POWDERS.indexOf(k) > -1 || PARTS[k]; })) notes.push('Tell me their weight and I’ll give you the exact scoop size.');
    else if (!S.species) notes.push('Is this for a dog or a cat?');
    if (notes.length) h += '<p class="am-note">' + notes.map(esc).join(' ') + '</p>';
    return h;
  }

  function send(t) {
    t = (t || '').trim();
    if (!t) return;
    say(esc(t), 'you');
    parse(t); S.turns++;
    var typing = say('<span class="am-dots"><i></i><i></i><i></i></span>', 'bot');
    setTimeout(function () { typing.innerHTML = reply(); log.scrollTop = log.scrollHeight; }, 650);
    root.classList.add('is-chatting');
  }

  form.addEventListener('submit', function (e) { e.preventDefault(); send(input.value); input.value = ''; input.style.height = ''; });
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit')); } });
  input.addEventListener('input', function () { input.style.height = 'auto'; input.style.height = Math.min(input.scrollHeight, 140) + 'px'; });
  root.querySelectorAll('[data-am-chip]').forEach(function (b) { b.addEventListener('click', function () { send(b.textContent); }); });
  if (reset) reset.addEventListener('click', function () { fresh(); log.innerHTML = ''; say(root.querySelector('[data-am-hello]').innerHTML, 'bot'); root.classList.remove('is-chatting'); input.focus(); });

  log.addEventListener('click', function (e) {
    var b = e.target.closest('.am-add');
    if (!b) return;
    b.disabled = true; var lbl = b.textContent; b.textContent = 'Adding…';
    var root_ = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var drawer = document.querySelector('cart-drawer');
    // Build the drawer first, and get its new HTML back from the same add request, so it only opens once the item is in it.
    try { if (drawer && drawer.init) drawer.init(); } catch (e) {}
    var sections = [];
    try { if (drawer && drawer.getSectionsToRender) sections = drawer.getSectionsToRender().map(function (x) { return x.id; }); } catch (e) {}
    var body = { id: +b.dataset.v, quantity: 1 };
    if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
    fetch(root_ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (res) {
        b.textContent = 'Added ✓';
        var done = false;
        if (drawer && drawer.renderContents && res.sections) { try { drawer.renderContents(res); done = true; } catch (e) {} }
        if (!done) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { b.textContent = lbl; b.disabled = false; }, 2500);
      })
      .catch(function () { window.location.href = root_ + 'cart/add?id=' + b.dataset.v + '&quantity=1'; });
  });
})();
